import React from 'react';

import gql from 'graphql-tag';
import PropTypes from 'prop-types';
import { Mutation } from 'react-apollo';

import ErrorModal from '../ErrorModal';
import MutationRequest from '../MutationRequest';

export const CREATE_CHECKBOX_ANSWER = gql`
  mutation answerCheckbox(
    $selectedAnswers: [QuestionAnswerCheckboxResponseCheckboxInputType]
    $contentSnippetQuestionId: Int!
    $status: EQuestionAnswerStatus
    $contentPageId: Int!
  ) {
    questionAnswer {
      setAnswer(
        answerCheckbox: {
          selectedAnswers: $selectedAnswers
          contentSnippetQuestionId: $contentSnippetQuestionId
          status: $status
          contentPageId: $contentPageId
        }
      ) {
        id
      }
    }
  }
`;

const createCheckboxAnswer = ({
  selectedAnswers,
  contentSnippetQuestionId,
  status,
  contentPageId,
  // userFlowStepId,
  onError,
  onSuccessResult,
}) => (
  <Mutation mutation={CREATE_CHECKBOX_ANSWER}>
    {(AnswerSL, { loading, error, data }) => {
      const variables = {
        selectedAnswers,
        contentSnippetQuestionId,
        status,
        contentPageId,
        // userFlowStepId,
      };

      if (error) {
        return <ErrorModal error={error} onError={onError} />;
      }
      if (data) {
        onSuccessResult(data.questionAnswer.setAnswer);
      }

      return (
        <MutationRequest
          isLoading={loading}
          mutation={AnswerSL}
          variables={variables}
        />
      );
    }}
  </Mutation>
);

createCheckboxAnswer.propTypes = {
  contentPageId: PropTypes.number.isRequired,
  contentSnippetQuestionId: PropTypes.number.isRequired,
  onError: PropTypes.func.isRequired,
  onSuccessResult: PropTypes.func.isRequired,
  selectedAnswers: PropTypes.arrayOf.isRequired,
  status: PropTypes.string,
  // userFlowStepId: PropTypes.number,
};

createCheckboxAnswer.defaultProps = {
  status: 'NO_RESPONSE',
  // userFlowStepId: 1,
};

export default createCheckboxAnswer;
